((homepageReviews, $) => {
  'use strict';

  const $dom = {};

  const cacheDom = () => {
    $dom.homepageReviews = $('.home-reviews__sliders-container');
  };

  const bindUIActions = () => {
    $dom.homepageReviews.slick({
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: true,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 5000,
      centerPadding: '0px',
      responsive: [
        {
          breakpoint: 768,
          settings: {},
        },
      ],
    });
  };

  const init = () => {
    cacheDom();
    bindUIActions();
  };

  homepageReviews.init = init;
  
})((window.homepageReviews = window.homepageReviews || {}), jQuery);
